// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2fehD","productName":"Table_productName__pmD-m"};